import { createEntityAdapter, createSlice, EntityState } from '@reduxjs/toolkit';

export interface Article {
    uri: string;
    title: string;
    type: 'article';
}
export type ArticlesRootState = {
    entities: {
        articles: EntityState<Article>;
    };
};

export const articleAdapter = createEntityAdapter<Article>({
    selectId: (article) => article.uri,
    sortComparer: (a, b) => a.title.localeCompare(b.title),
});

export const articleSlice = createSlice({
    name: 'articles',
    initialState: articleAdapter.getInitialState(),
    reducers: {
        addOne: articleAdapter.addOne,
        addMany: articleAdapter.addMany,
        setAll: articleAdapter.setAll,
    },
});

export const articlesSelector = articleAdapter.getSelectors<ArticlesRootState>((state) => state.entities.articles);
export type ArticleSelectorType = typeof articlesSelector;

export const articleActions = articleSlice.actions;
export type ArticleActionsType = typeof articleActions;
